import {
  ButtonProps,
  CenterProps,
  chakra,
  ModalHeaderProps,
} from "@chakra-ui/react";
import { Link } from "@ui/components/link";
import { randomId } from "@ui/utils";
import { PropsWithChildren } from "react";
import { atom } from "recoil";

export type ErrorModalProps = PropsWithChildren<{
  isOpen: boolean;
  title?: string;
  content?: string | React.ReactNode;
  actions?: React.ReactNode;
  headerSx?: ModalHeaderProps;
  contentSx?: CenterProps;
  closeButton?: {
    label: string;
    props: ButtonProps;
  };
}>;

export const errorContentState = atom<ErrorModalProps>({
  key: `errorContentState/${randomId(15)}`,
  default: {
    title: "Cannot Retrieve Your Location",
    content:
      "Permission for accessing your location was denied by your browser",
    children: (
      <chakra.div textAlign="center">
        <chakra.p apply="styles.mdx.p" ml="1.25rem" pt="4">
          You'll need to reset your browser's geolocation permissions.{" "}
        </chakra.p>
        <Link
          apply="styles.mdx.a"
          href="https://www.lifewire.com/denying-access-to-your-location-4027789"
          isExternal
        >
          Click Here for Instructions
        </Link>
      </chakra.div>
    ),
    isOpen: true,
  },
});
